import { css, SerializedStyles } from '@emotion/react'
import { colors } from 'plume-ui'

type Props = {
  dataTestId?: string
  condition: boolean
  idx: number
  handleSet: (event: React.MouseEvent<HTMLElement>) => void
  label: string
  _css?: SerializedStyles
  icon?: string
  iconCss?: SerializedStyles
}

export const OptionDropdownItem: React.FC<Props> = ({
  dataTestId,
  condition,
  idx,
  handleSet,
  label,
  _css,
  icon,
  iconCss,
}) => {
  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault()
    handleSet(e)
  }
  return (
    <li
      key={`${idx}-${label}`}
      data-test-id={dataTestId}
      className={condition ? 'item is-selected' : 'item'}
      css={css`
        height: 30px;
        transition: background-color 0.3s ease;

        &:hover {
          background-color: ${colors.backgroundGray};
        }

        ${_css}
      `}
    >
      <a
        css={css`
          display: flex;
          height: 100%;
          line-height: 18px;
          font-size: 14px;
          gap: 10px;
          align-items: center;
          padding: 0 10px 0 10px;
          overflow: hidden;
        `}
        onClick={handleClick}
      >
        {condition ? (
          <i
            className={`icomoon ${icon || 'icon-check1'}`}
            css={css`
              flex-shrink: 1;
              min-width: 14px;
              ${iconCss}
            `}
          />
        ) : (
          <span
            css={css`
              flex-shrink: 1;
              min-width: 14px;
            `}
          ></span>
        )}
        <span
          css={css`
            flex: 1;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          `}
        >
          {label}
        </span>
      </a>
    </li>
  )
}
